<template>
						<div
							style="
								position: sticky;
								top: 30px;
								width: 509px;
								display: flow-root;
							">
							<!-- 白色主题 -->
							<div class="phone">
								<div class="title">{{ $t('theme.list.767480-0') }}</div>
								<template v-if="currentCard == 0">
									<div style="width: 100%">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
								<template v-if="currentCard == 1">
									<div
										style="width: 100%; position: relative">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="
												position: absolute;
												width: 506px;
												height: 836px;
												background-color: #000000;
												top: 80px;
												opacity: 0.3;
												z-index: 2;
											"></div>
										<div
											style="
												position: absolute;
												width: 506px;
												height: 626px;
												background: none;
												top: 290px;
												z-index: 3;
											">
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.cart.background
														? 'background: url(' +
														  ruleForm.cart.background +
														  '); background-size: 100% 100%; background-repeat: no-repeat; background-position: center; width: 70%; height: 100%; display: flex; justify-content: center;'
														: 'background: #e5e9f2; width: 70%; height: 100%; display: flex; justify-content: center;'
												">
												<div style="width: 100%">
													<div
														style="
															display: block;
															margin: 20px auto 40px auto;
															width: 22px;
															position: relative;
														">
														<img
															v-if="ruleForm.cart.cartIcon"
															:src="ruleForm.cart.cartIcon"
															:class="moveField == 'cartIcon' ? 'images' : ''"
															:style="
																'display: block; opacity: ' +
																ruleForm.cart.cartIconTransparent +
																'; width: 22px;'
															" />
														<div
															style="
																position: absolute;
																top: -5px;
																right: -20px;
																background-color: white;
																padding: 0 6px;
																border-radius: 100%;
																color: rgb(254, 160, 78);
																font-weight: bold;
																font-size: 14px;
															">
															5
														</div>
													</div>
													<div style="width: 100%; margin-top: 16px">
														<div
															style="
																width: 75%;
																display: flex;
																margin: 0px auto;
																position: relative;
																background-color: #f2f2f2;
																height: 55px;
																border-radius: 5px;
																border: 2px solid #d2d2d2;
															">
															<img
																v-if="ruleForm.cart.delBtn"
																:src="ruleForm.cart.delBtn"
																:class="moveField == 'delBtn' ? 'images' : ''"
																:style="
																	'width: 20px; height: 20px; display: block; position: absolute; left: -10px; top: -9px; opacity: ' +
																	ruleForm.cart.delBtnTransparent +
																	';'
																" />
															<div
																style="
																	width: 35px;
																	height: 35px;
																	margin: 10px;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div
																style="
																	width: 52px;
																	height: 35px;
																	margin: 10px 10px 10px 0;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div style="display: flex">
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		border-radius: 5px 0 0 5px;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.reduce"
																		:src="ruleForm.cart.reduce"
																		:class="
																			moveField == 'reduce' ? 'images' : ''
																		"
																		:style="
																			'width: 16px; display: block; opacity: ' +
																			ruleForm.cart.reduceTransparent +
																			';'
																		" />
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		font-size: 20px;
																		color: #fea04e;
																		font-weight: bold;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	2
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-radius: 0 5px 5px 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.add"
																		:src="ruleForm.cart.add"
																		:class="moveField == 'add' ? 'images' : ''"
																		:style="
																			'width: 16px; height: 16px; display: block; opacity: ' +
																			ruleForm.cart.addTransparent +
																			';'
																		" />
																</div>
															</div>
														</div>
													</div>
													<div style="width: 100%; margin-top: 16px">
														<div
															style="
																width: 75%;
																display: flex;
																margin: 0px auto;
																position: relative;
																background-color: #f2f2f2;
																height: 55px;
																border-radius: 5px;
																border: 2px solid #d2d2d2;
															">
															<img
																v-if="ruleForm.cart.delBtn"
																:src="ruleForm.cart.delBtn"
																:class="moveField == 'delBtn' ? 'images' : ''"
																:style="
																	'width: 20px; height: 20px; display: block; position: absolute; left: -10px; top: -9px; opacity: ' +
																	ruleForm.cart.delBtnTransparent +
																	';'
																" />
															<div
																style="
																	width: 35px;
																	height: 35px;
																	margin: 10px;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div
																style="
																	width: 52px;
																	height: 35px;
																	margin: 10px 10px 10px 0;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div style="display: flex">
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		border-radius: 5px 0 0 5px;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.reduceUnavailable"
																		:src="ruleForm.cart.reduceUnavailable"
																		:class="
																			moveField == 'reduceUnavailable'
																				? 'images'
																				: ''
																		"
																		:style="
																			'width: 16px; display: block; opacity: ' +
																			ruleForm.cart
																				.reduceUnavailableTransparent +
																			';'
																		" />
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		font-size: 20px;
																		color: #fea04e;
																		font-weight: bold;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	2
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-radius: 0 5px 5px 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.add"
																		:src="ruleForm.cart.add"
																		:class="moveField == 'add' ? 'images' : ''"
																		:style="
																			'width: 16px; height: 16px; display: block; opacity: ' +
																			ruleForm.cart.addTransparent +
																			';'
																		" />
																</div>
															</div>
														</div>
													</div>
													<div style="width: 100%; margin-top: 16px">
														<div
															style="
																width: 75%;
																display: flex;
																margin: 0px auto;
																position: relative;
																background-color: #f2f2f2;
																height: 55px;
																border-radius: 5px;
																border: 2px solid #d2d2d2;
															">
															<img
																v-if="ruleForm.cart.delBtn"
																:src="ruleForm.cart.delBtn"
																:class="moveField == 'delBtn' ? 'images' : ''"
																:style="
																	'width: 20px; height: 20px; display: block; position: absolute; left: -10px; top: -9px; opacity: ' +
																	ruleForm.cart.delBtnTransparent +
																	';'
																" />
															<div
																style="
																	width: 35px;
																	height: 35px;
																	margin: 10px;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div
																style="
																	width: 52px;
																	height: 35px;
																	margin: 10px 10px 10px 0;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div style="display: flex">
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		border-radius: 5px 0 0 5px;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.reduceUnavailable"
																		:src="ruleForm.cart.reduceUnavailable"
																		:class="
																			moveField == 'reduceUnavailable'
																				? 'images'
																				: ''
																		"
																		:style="
																			'width: 16px; display: block; opacity: ' +
																			ruleForm.cart
																				.reduceUnavailableTransparent +
																			';'
																		" />
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		font-size: 20px;
																		color: #fea04e;
																		font-weight: bold;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	2
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-radius: 0 5px 5px 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.add"
																		:src="ruleForm.cart.add"
																		:class="moveField == 'add' ? 'images' : ''"
																		:style="
																			'width: 16px; height: 16px; display: block; opacity: ' +
																			ruleForm.cart.addTransparent +
																			';'
																		" />
																</div>
															</div>
														</div>
													</div>
													<div style="width: 100%; margin-top: 16px">
														<div
															style="
																width: 75%;
																display: flex;
																margin: 0px auto;
																position: relative;
																background-color: #f2f2f2;
																height: 55px;
																border-radius: 5px;
																border: 2px solid #d2d2d2;
															">
															<img
																v-if="ruleForm.cart.delBtn"
																:src="ruleForm.cart.delBtn"
																:class="moveField == 'delBtn' ? 'images' : ''"
																:style="
																	'width: 20px; height: 20px; display: block; position: absolute; left: -10px; top: -9px; opacity: ' +
																	ruleForm.cart.delBtnTransparent +
																	';'
																" />
															<div
																style="
																	width: 35px;
																	height: 35px;
																	margin: 10px;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div
																style="
																	width: 52px;
																	height: 35px;
																	margin: 10px 10px 10px 0;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div style="display: flex">
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		border-radius: 5px 0 0 5px;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.reduce"
																		:src="ruleForm.cart.reduce"
																		:class="
																			moveField == 'reduce' ? 'images' : ''
																		"
																		:style="
																			'width: 16px; display: block; opacity: ' +
																			ruleForm.cart.reduceTransparent +
																			';'
																		" />
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		font-size: 20px;
																		color: #fea04e;
																		font-weight: bold;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	2
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-radius: 0 5px 5px 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.add"
																		:src="ruleForm.cart.add"
																		:class="moveField == 'add' ? 'images' : ''"
																		:style="
																			'width: 16px; height: 16px; display: block; opacity: ' +
																			ruleForm.cart.addTransparent +
																			';'
																		" />
																</div>
															</div>
														</div>
													</div>
													<div style="width: 100%; margin-top: 16px">
														<div
															style="
																width: 75%;
																display: flex;
																margin: 0px auto;
																position: relative;
																background-color: #f2f2f2;
																height: 55px;
																border-radius: 5px;
																border: 2px solid #d2d2d2;
															">
															<img
																v-if="ruleForm.cart.delBtn"
																:src="ruleForm.cart.delBtn"
																:class="moveField == 'delBtn' ? 'images' : ''"
																:style="
																	'width: 20px; height: 20px; display: block; position: absolute; left: -10px; top: -9px; opacity: ' +
																	ruleForm.cart.delBtnTransparent +
																	';'
																" />
															<div
																style="
																	width: 35px;
																	height: 35px;
																	margin: 10px;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div
																style="
																	width: 52px;
																	height: 35px;
																	margin: 10px 10px 10px 0;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div style="display: flex">
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		border-radius: 5px 0 0 5px;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.reduce"
																		:src="ruleForm.cart.reduce"
																		:class="
																			moveField == 'reduce' ? 'images' : ''
																		"
																		:style="
																			'width: 16px; display: block; opacity: ' +
																			ruleForm.cart.reduceTransparent +
																			';'
																		" />
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		font-size: 20px;
																		color: #fea04e;
																		font-weight: bold;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	2
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-radius: 0 5px 5px 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.add"
																		:src="ruleForm.cart.add"
																		:class="moveField == 'add' ? 'images' : ''"
																		:style="
																			'width: 16px; height: 16px; display: block; opacity: ' +
																			ruleForm.cart.addTransparent +
																			';'
																		" />
																</div>
															</div>
														</div>
													</div>
													<div
														style="
															width: 76%;
															padding: 12px 12%;
															margin-top: 10px;
															display: flex;
															align-items: center;
														">
														<div
															style="
																width: 65%;
																font-size: 20px;
																font-weight: bold;
															">
															Total Amount
														</div>
														<div
															style="font-size: 25px; color: rgb(254, 160, 78)">
															<span>38.88</span>
															<span
																style="
																	font-size: 12px;
																	font-weight: bold;
																	margin-left: 3px;
																"
																>{{ $t('theme.list.767480-1') }}</span
															>
														</div>
													</div>
													<div
														style="
															display: flex;
															align-items: center;
															justify-content: center;
															width: 70%;
															margin: 0 15%;
														">
														<img
															v-if="ruleForm.cart.cartClear"
															:class="moveField == 'cartClear' ? 'images' : ''"
															:src="ruleForm.cart.cartClear"
															:style="
																'display: block; width: 135px; margin-right: 10px; opacity: ' +
																ruleForm.cart.cartClearTransparent +
																';'
															" />
														<img
															v-if="ruleForm.cart.buyBtn"
															:class="moveField == 'buyBtn' ? 'images' : ''"
															:src="ruleForm.cart.buyBtn"
															:style="
																'display: block; width: 135px; opacity: ' +
																ruleForm.cart.buyBtnTransparent +
																';'
															" />
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
								<template v-if="currentCard == 2">
									<div
										style="width: 100%; position: relative">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="
												position: absolute;
												width: 506px;
												height: 836px;
												background-color: #000000;
												top: 80px;
												opacity: 0.3;
												z-index: 2;
											"></div>
										<div
											style="
												position: absolute;
												width: 506px;
												height: 626px;
												background: none;
												top: 290px;
												z-index: 3;
											">
											<div
												style="
													width: 92%;
													height: 100%;
													background-color: white;
													padding: 4%;
													border-radius: 15px 15px 0 0;
												">
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.pay.closeBtn"
														:class="moveField == 'closeBtn' ? 'images' : ''"
														:src="ruleForm.pay.closeBtn"
														:style="
															'display: block; opacity: ' +
															ruleForm.pay.closeBtnTransparent +
															'; height: 32px;'
														" />
													<div
														style="
															width: 78%;
															height: 32px;
															margin: 0 3%;
															background-color: #d3dce6;
														"></div>
													<img
														v-if="ruleForm.pay.couponBtn"
														:class="moveField == 'couponBtn' ? 'images' : ''"
														:src="ruleForm.pay.couponBtn"
														:style="
															'display: block; opacity: ' +
															ruleForm.pay.couponBtnTransparent +
															'; height: 32px;'
														" />
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div
														style="
															width: 40%;
															margin-right: 3%;
															height: 120px;
															background-color: #d3dce6;
														"></div>
													<div
														style="
															width: 54%;
															margin-left: 3%;
															height: 120px;
															background-color: #d3dce6;
														"></div>
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div
														style="
															width: 110px;
															height: 110px;
															background-color: #d3dce6;
														"></div>
												</div>
												<div
													style="
														width: 100%;
														height: 50px;
														margin-top: 6%;
														background-color: #d3dce6;
													"></div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div style="width: 50%">
														<div
															style="
																width: 100%;
																display: block;
																position: relative;
															">
															<img
																v-if="ruleForm.pay.qrCodeBtn"
																:class="
																	moveField == 'qrCodeBtn' ? 'images' : ''
																"
																:src="ruleForm.pay.qrCodeBtn"
																:style="
																	'width: 100%; height: 68px; display: block; opacity: ' +
																	ruleForm.pay.qrCodeBtnTransparent +
																	';'
																" />
															<img
																v-if="ruleForm.pay.qrCodeImg"
																:class="
																	moveField == 'qrCodeImg' ? 'images' : ''
																"
																:src="ruleForm.pay.qrCodeImg"
																style="
																	width: 36.5px;
																	height: 36.5px;
																	display: block;
																	position: absolute;
																	top: 15px;
																	left: 48px;
																" />
														</div>
														<div
															style="
																width: 100%;
																display: block;
																position: relative;
															">
															<img
																v-if="ruleForm.pay.coinBtn"
																:class="moveField == 'coinBtn' ? 'images' : ''"
																:src="ruleForm.pay.coinBtn"
																:style="
																	'width: 100%; display: block; opacity: ' +
																	ruleForm.pay.coinBtnTransparent +
																	';'
																" />
															<img
																v-if="ruleForm.pay.coinImg"
																:class="moveField == 'coinImg' ? 'images' : ''"
																:src="ruleForm.pay.coinImg"
																style="
																	width: 36.5px;
																	height: 36.5px;
																	display: block;
																	position: absolute;
																	top: 15px;
																	left: 48px;
																" />
														</div>
													</div>
													<div style="width: 50%">
														<div
															style="
																width: 100%;
																display: block;
																position: relative;
															">
															<img
																v-if="ruleForm.pay.cashBtn"
																:class="moveField == 'cashBtn' ? 'images' : ''"
																:src="ruleForm.pay.cashBtn"
																:style="
																	'width: 100%; display: block; opacity: ' +
																	ruleForm.pay.cashBtnTransparent +
																	';'
																" />
															<img
																v-if="ruleForm.pay.cashImg"
																:class="moveField == 'cashImg' ? 'images' : ''"
																:src="ruleForm.pay.cashImg"
																style="
																	width: 36.5px;
																	height: 36.5px;
																	display: block;
																	position: absolute;
																	top: 15px;
																	left: 48px;
																" />
														</div>
														<div
															style="
																width: 100%;
																display: block;
																position: relative;
															">
															<img
																v-if="ruleForm.pay.creditCardBtn"
																:class="
																	moveField == 'creditCardBtn' ? 'images' : ''
																"
																:src="ruleForm.pay.creditCardBtn"
																:style="
																	'width: 100%; display: block; opacity: ' +
																	ruleForm.pay.creditCardBtnTransparent +
																	';'
																" />
															<img
																v-if="ruleForm.pay.creditCardImg"
																:class="
																	moveField == 'creditCardImg' ? 'images' : ''
																"
																:src="ruleForm.pay.creditCardImg"
																style="
																	width: 36.5px;
																	height: 36.5px;
																	display: block;
																	position: absolute;
																	top: 15px;
																	left: 48px;
																" />
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
								<template v-if="currentCard == 3">
									<div
										style="width: 100%; position: relative">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="
												position: absolute;
												width: 506px;
												height: 836px;
												background-color: #000000;
												top: 80px;
												opacity: 0.3;
												z-index: 2;
											"></div>
										<div
											style="
												position: absolute;
												width: 506px;
												height: 626px;
												background: none;
												top: 290px;
												z-index: 3;
											">
											<div
												style="
													width: 92%;
													height: 100%;
													background-color: white;
													padding: 4%;
													border-radius: 15px 15px 0 0;
												">
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.pay.closeBtn"
														:class="moveField == 'closeBtn' ? 'images' : ''"
														:src="ruleForm.pay.closeBtn"
														:style="
															'display: block; height: 32px; opacity: ' +
															ruleForm.pay.closeBtnTransparent +
															';'
														" />
													<div
														style="
															width: 78%;
															height: 32px;
															margin: 0 3%;
															background-color: #d3dce6;
														"></div>
													<img
														v-if="ruleForm.pay.couponBtn"
														:class="moveField == 'couponBtn' ? 'images' : ''"
														:src="ruleForm.pay.couponBtn"
														:style="
															'display: block; height: 32px; opacity: ' +
															ruleForm.pay.couponBtnTransparent +
															';'
														" />
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div
														style="
															width: 80%;
															height: 80px;
															background-color: #d3dce6;
														"></div>
												</div>
												<div
													style="
														width: 100%;
														height: 57px;
														margin-top: 8%;
														position: relative;
													">
													<div
														style="
															position: absolute;
															top: 0;
															left: 0;
															z-index: 2;
															width: 100%;
															height: 100%;
															display: flex;
															align-items: center;
															justify-content: center;
														">
														<div style="width: 30%; text-align: center">
															<img
																v-if="ruleForm.buy.successIcon"
																:class="
																	moveField == 'successIcon' ? 'images' : ''
																"
																:src="ruleForm.buy.successIcon"
																:style="
																	'width: 32px; height: 32px; display: block; margin: 0 auto; opacity: ' +
																	ruleForm.buy.successIconTransparent +
																	';'
																" />
															<div style="width: 100%; margin-top: 5px">
																Paying...
															</div>
														</div>
														<div style="width: 40%; text-align: center">
															<img
																v-if="ruleForm.buy.failIcon"
																:class="moveField == 'failIcon' ? 'images' : ''"
																:src="ruleForm.buy.failIcon"
																:style="
																	'width: 32px; height: 32px; display: block; margin: 0 auto; opacity: ' +
																	ruleForm.buy.failIconTransparent +
																	';'
																" />
															<div style="width: 100%; margin-top: 5px">
																Paid...
															</div>
														</div>
														<div style="width: 30%; text-align: center">
															<div
																style="
																	width: 26px;
																	height: 26px;
																	display: block;
																	border: 3px solid #d3dce6;
																	margin: 0 auto;
																	border-radius: 100%;
																"></div>
															<div style="width: 100%; margin-top: 5px">
																Delivered...
															</div>
														</div>
													</div>
													<div
														style="
															position: absolute;
															top: 15px;
															left: 86px;
															z-index: 1;
															width: 28%;
															height: 3px;
															background-color: #ff8924;
														"></div>
													<div
														style="
															position: absolute;
															top: 15px;
															left: 249px;
															z-index: 1;
															width: 28%;
															height: 3px;
															background-color: #d3dce6;
														"></div>
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.buy.load"
														:class="moveField == 'load' ? 'images' : ''"
														:src="ruleForm.buy.load"
														style="width: 26px; height: 26px; display: block" />
													<div
														style="
															margin-left: 3%;
															height: 30px;
															line-height: 30px;
															font-size: 16px;
															text-align: center;
														">
														Delivering，please wait...
													</div>
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div
														style="
															width: 120px;
															margin-right: 5%;
															text-align: center;
														">
														<img
															v-if="ruleForm.buy.stockUp"
															:class="moveField == 'stockUp' ? 'images' : ''"
															:src="ruleForm.buy.stockUp"
															style="
																width: 60px;
																height: 60px;
																display: block;
																margin: 0 auto;
															" />
														<div style="margin-top: 5px">Successfully Paid</div>
													</div>
													<div
														style="
															width: 120px;
															margin-left: 5%;
															text-align: center;
														">
														<img
															v-if="ruleForm.buy.buyFail"
															:class="moveField == 'buyFail' ? 'images' : ''"
															:src="ruleForm.buy.buyFail"
															:style="
																'width: 60px; height: 60px; display: block; margin: 0 auto; opacity: ' +
																ruleForm.buy.buyFailTransparent +
																';'
															" />
														<div style="margin-top: 5px">Fail Paid</div>
													</div>
												</div>
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.buy.sell"
														:class="moveField == 'sell' ? 'images' : ''"
														:src="ruleForm.buy.sell"
														style="height: 120px; display: block" />
												</div>
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.buy.buyAgain"
														:class="moveField == 'buyAgain' ? 'images' : ''"
														:src="ruleForm.buy.buyAgain"
														:style="
															'width: 208.5px; height: 67px; display: block; opacity: ' +
															ruleForm.buy.buyAgainTransparent +
															';'
														" />
												</div>
											</div>
										</div>
									</div>
								</template>
								<template v-if="currentCard == 4">
									<div
										style="width: 100%; position: relative">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="
												position: absolute;
												width: 506px;
												height: 836px;
												background-color: #000000;
												top: 80px;
												opacity: 0.3;
												z-index: 2;
											"></div>
										<div
											style="
												position: absolute;
												width: 506px;
												height: 626px;
												background: none;
												top: 290px;
												z-index: 3;
											">
											<div
												style="
													width: 92%;
													height: 100%;
													background-color: white;
													padding: 4%;
													border-radius: 15px 15px 0 0;
												">
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.pay.closeBtn"
														:class="moveField == 'closeBtn' ? 'images' : ''"
														:src="ruleForm.pay.closeBtn"
														:style="
															'display: block; height: 32px; opacity: ' +
															ruleForm.pay.closeBtnTransparent +
															';'
														" />
													<div
														style="
															width: 87%;
															height: 32px;
															margin: 0 3%;
															background-color: #d3dce6;
														"></div>
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div style="width: 100%; text-align: center">
														Spend $2, get 50% discount.
													</div>
												</div>
												<div
													style="
														width: 100%;
														margin: 6% 0;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.discount.discount"
														:class="moveField == 'discount' ? 'images' : ''"
														:src="ruleForm.discount.discount"
														:style="
															'display: block; opacity: ' +
															ruleForm.discount.discountTransparent +
															';'
														" />
												</div>
												<div
													style="
														width: 100%;
														height: 50px;
														background-color: #d3dce6;
													"></div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.discount.next"
														:class="moveField == 'next' ? 'images' : ''"
														:src="ruleForm.discount.next"
														:style="
															'width: 50%; display: block; opacity: ' +
															ruleForm.discount.nextTransparent +
															';'
														" />
													<img
														v-if="ruleForm.discount.back"
														:class="moveField == 'back' ? 'images' : ''"
														:src="ruleForm.discount.back"
														:style="
															'width: 50%; display: block; opacity: ' +
															ruleForm.discount.backTransparent +
															';'
														" />
												</div>
											</div>
										</div>
									</div>
								</template>
								<template v-if="currentCard == 5">
									<div
										style="width: 100%; position: relative">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="moveField == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														  ruleForm.goodsShow.background +
														  '); opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														  ruleForm.goodsShow.backgroundTransparent +
														  '; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="moveField == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="moveField == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="moveField == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																moveField == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="moveField == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="width: 90px; height: 43px; margin: 13px auto 0 auto; text-align: center; border-radius: 3px;"
														:style="{ 'background-color': ruleForm.backColor.btnArea || '#ffffff' }">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	moveField == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="
												position: absolute;
												width: 506px;
												height: 836px;
												background-color: #000000;
												top: 80px;
												opacity: 0.3;
												z-index: 2;
											"></div>
										<div
											style="
												position: absolute;
												width: 506px;
												height: 626px;
												background: none;
												top: 290px;
												z-index: 3;
											">
											<div
												style="
													width: 92%;
													height: 100%;
													background-color: white;
													padding: 4%;
													border-radius: 15px 15px 0 0;
												">
												<!-- 顶部 -->
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.age.cancelBtn"
														:class="moveField == 'cancelBtn' ? 'images' : ''"
														:src="ruleForm.age.cancelBtn"
														:style="
															'display: block; height: 32px; opacity: ' +
															ruleForm.age.cancelBtnTransparent +
															';'
														" />
													<div
														style="
															width: 87%;
															height: 32px;
															margin: 0 3%;
															background-color: #d3dce6;
														"></div>
												</div>
												<!-- 过程图 -->
												<div
													style="
														width: 100%;
														height: 57px;
														margin-top: 8%;
														position: relative;
														display: flex;
														align-items: center;
														justify-content: center;
													">
													<img
														v-if="ruleForm.age.progressBarTip"
														:class="
															moveField == 'progressBarTip' ? 'images' : ''
														"
														:src="ruleForm.age.progressBarTip"
														:style="
															'width: 57px; display: block; opacity: ' +
															ruleForm.age.progressBarTipTransparent +
															';'
														" />
													<div
														style="
															width: 10%;
															height: 0;
															border-bottom: dotted 2px #ccc;
															margin: 0 3px;
															opacity: 0.7;
														"></div>
													<img
														v-if="ruleForm.age.progressBarGray"
														:class="
															moveField == 'progressBarGray' ? 'images' : ''
														"
														:src="ruleForm.age.progressBarGray"
														:style="
															'width: 57px; display: block; opacity: ' +
															ruleForm.age.progressBarGrayTransparent +
															';'
														" />
													<div
														style="
															width: 10%;
															height: 0;
															border-bottom: dotted 2px #ccc;
															margin: 0 3px;
															opacity: 0.7;
														"></div>
													<img
														v-if="ruleForm.age.progressBarSuccess"
														:class="
															moveField == 'progressBarSuccess' ? 'images' : ''
														"
														:src="ruleForm.age.progressBarSuccess"
														:style="
															'width: 57px; display: block; opacity: ' +
															ruleForm.age.progressBarSuccessTransparent +
															';'
														" />
												</div>
												<div
													style="
														width: 100%;
														height: 100px;
														background-color: #d3dce6;
														margin-top: 8%;
													"></div>
												<!-- 二维码等刷卡提示 -->
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: space-evenly;
													">
													<img
														v-if="ruleForm.age.qrCodeTip"
														:class="moveField == 'qrCodeTip' ? 'images' : ''"
														:src="ruleForm.age.qrCodeTip"
														:style="
															'width: 30%; display: block; opacity: ' +
															ruleForm.age.qrCodeTipTransparent +
															';'
														" />
													<img
														v-if="ruleForm.age.qrCodeTip"
														:class="moveField == 'qrCodeTip' ? 'images' : ''"
														:src="ruleForm.age.qrCodeTip"
														:style="
															'width: 30%; display: block; opacity: ' +
															ruleForm.age.qrCodeTipTransparent +
															';'
														" />
													<img
														v-if="ruleForm.age.cardTip2"
														:class="moveField == 'cardTip2' ? 'images' : ''"
														:src="ruleForm.age.cardTip2"
														:style="
															'width: 30%; display: block; opacity: ' +
															ruleForm.age.cardTip2Transparent +
															';'
														" />
												</div>
												<!-- 成功、失败 -->
												<div
													style="
														width: 100%;
														margin-top: 2%;
														display: flex;
														justify-content: space-evenly;
													">
													<img
														v-if="ruleForm.age.successIcon"
														:class="moveField == 'successIcon' ? 'images' : ''"
														:src="ruleForm.age.successIcon"
														:style="
															'width: 20%; display: block; opacity: ' +
															ruleForm.age.successIconTransparent +
															';'
														" />
													<img
														v-if="ruleForm.age.failIcon"
														:class="moveField == 'failIcon' ? 'images' : ''"
														:src="ruleForm.age.failIcon"
														:style="
															'width: 20%; display: block; opacity: ' +
															ruleForm.age.failIconTransparent +
															';'
														" />
												</div>
												<!-- 去购买 -->
												<div
													style="
														width: 100%;
														margin-top: 4%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.age.goShopping"
														:class="moveField == 'goShopping' ? 'images' : ''"
														:src="ruleForm.age.goShopping"
														:style="
															'width: 50%; display: block; opacity: ' +
															ruleForm.age.goShoppingTransparent +
															';'
														" />
												</div>
											</div>
										</div>
									</div>
								</template>
							</div>
						</div>
</template>

<script>
export default {
	name: "ThemePreviewPanel",
	props: {
		currentCard: {
			type: Number,
			required: true
		},
		moveField: {
			type: String,
			default: ""
		},
		ruleForm: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.phone {
	position: relative;
	width: 509px;
	height: 886px;
	display: flow-root;
	border-radius: 15px;
}
.phone .title {
	width: 489px;
	height: 50px;
	line-height: 50px;
	display: flex;
	background-color: #ebeef5;
	border-radius: 15px 15px 0 0;
	padding-left: 20px;
}
.images {
	animation: blink 1s linear infinite;
}
@keyframes blink {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>
